import { useEffect, useState } from 'react';

interface Props {
  title: string;
  subtitle: string;
  cta: string;
  href: string;
  onClick: () => void;
  /** id секции героя — полоса появляется, когда та ушла за экран. */
  watchId: string;
}

/**
 * Нижняя липкая полоса с CTA, только на узких экранах.
 *
 * Рендерится ВСЕГДА (не условно), а показывается классом: условный рендер
 * выкинул бы её текст из пререндеренного HTML.
 */
export function StickyCta({ title, subtitle, cta, href, onClick, watchId }: Props) {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const hero = document.getElementById(watchId);
    if (!hero || typeof IntersectionObserver === 'undefined') return;
    const io = new IntersectionObserver(([entry]) => setShown(!entry.isIntersecting), {
      threshold: 0.05,
    });
    io.observe(hero);
    return () => io.disconnect();
  }, [watchId]);

  return (
    <div
      className={`fixed inset-x-0 bottom-0 z-[60] flex items-center justify-between gap-2.5 border-t border-edge bg-bone-surface px-4 py-2.5 shadow-[0_-6px_24px_rgba(26,26,46,.08)] transition-transform duration-[250ms] sm:hidden ${
        shown ? 'translate-y-0' : 'translate-y-[110%]'
      }`}
      aria-hidden={!shown}
    >
      <div className="text-[13px] font-bold leading-[1.25]">
        {title}
        <small className="block font-semibold text-ink-soft">{subtitle}</small>
      </div>
      <a
        className="rounded-lg border-[1.5px] border-brand bg-brand px-4 py-[9px] text-sm font-bold text-white no-underline"
        href={href}
        onClick={onClick}
        tabIndex={shown ? 0 : -1}
      >
        {cta}
      </a>
    </div>
  );
}
